import { css, styled } from 'styled-components';

import { media } from 'src/styles/breakpoints';

export const StyledHeader = styled.div<{ $hasToolbar?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  width: 100%;
  min-width: 0;
  margin-bottom: 1rem;
  flex-shrink: 0;

  ${media.md} {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const HeaderTitle = styled.div`
  flex: 0 1 auto;
  min-width: 0;
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: ${({ theme }) => theme.dark};
`;

export const HeaderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 0 1 auto;
  min-width: 0;
  margin-left: auto;

  ${media.md} {
    margin-left: 0;
    width: 100%;
    flex-direction: row;
    align-items: center;
    flex-wrap: nowrap;
    gap: 0.5rem;
  }
`;

export const HeaderActions = styled.div<{ $reserve?: boolean }>`
  display: flex;
  align-items: center;
  /* Matches HeaderControls, so a page with two actions spaces them the same way
     as the gap between search and the action slot. */
  gap: 0.75rem;

  ${({ $reserve }) =>
    $reserve &&
    css`
      min-width: 5.5rem;
      min-height: 2.875rem;
    `}

  ${media.md} {
    width: auto;
    flex: 0 0 auto;

    ${({ $reserve }) =>
      $reserve &&
      css`
        min-height: 2.875rem;
      `}

    button {
      width: auto;
      align-self: auto;
      white-space: nowrap;
    }
  }
`;
